import clientUtils from "../utils/client-utils";
import constants from "../utils/const";

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  search(param) {
    const parameters =
      (param.page ? "?page=" + param.page : "?page=0") +
      (param.size ? "&size=" + param.size : "&size=10") +
      (param.lesson ? "&lesson=" + param.lesson : "") +
      (param.price ? "&price=" + param.price : "") +
      (param.type ? "&type=" + param.type : "") +
      (param.programId ? "&programId=" + param.programId : "") +
      (param.programName ? "&programName=" + param.programName : "") +
      (param.name ? "&name=" + param.name : "") +
      (param.ma ? "&ma=" + param.ma : "");

    return new Promise((resolve, reject) => {
      clientUtils
        .requestApi("get", constants.api.subject + parameters, {})
        .then((x) => {
          resolve(x);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  getById(id) {
    return new Promise((resolve, reject) => {
      clientUtils
        .requestApi("get", constants.api.subject + "/" + id, {})
        .then((x) => {
          resolve(x);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  create(body) {
    return new Promise((resolve, reject) => {
      clientUtils
        .requestApi("post", constants.api.subject, body)
        .then((x) => {
          resolve(x);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  update(body, id) {
    return new Promise((resolve, reject) => {
      clientUtils
        .requestApi("put", constants.api.subject + "/" + id, body)
        .then((x) => {
          resolve(x);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  delete(id) {
    return new Promise((resolve, reject) => {
      clientUtils
        .requestApi("delete", constants.api.subject + "/" + id, {})
        .then((x) => {
          resolve(x);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
};
